import { compressToEncodedURIComponent } from 'lz-string';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const serializeFilters = (filters) => {
  const filterParams = new URLSearchParams();
  Object.keys(filters).forEach((session) => {
    filterParams.set(session, filters[session].join(';'));
  });

  return compressToEncodedURIComponent(filterParams.toString());
};

export const useSessionFilters = (
  searchParams: URLSearchParams,
  setSearchParams: ReturnType<typeof useSearchParams>[1],
  filterParams: Record<string, any> | undefined,
  setFilterParamsState: ((filters: Record<string, any>) => void) | undefined,
  sessionIds: string[]
) => {
  const filters: Record<string, string[]> = Object.entries(
    filterParams ?? {}
  ).reduce((acc, [key, value]) => {
    if (sessionIds.includes(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});

  const setFilters = useCallback(
    (newFilters) => {
      if (setFilterParamsState) {
        const filterString = serializeFilters(newFilters);
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('filters', filterString);
        setSearchParams(newSearchParams);
        setFilterParamsState(newFilters);
      }
    },
    [searchParams, setFilterParamsState, setSearchParams]
  );

  const setFiltersForSession = (clauses: string[], sessionId: string) => {
    const newFilters = { ...filters };

    if (clauses.length === 0) {
      delete newFilters[sessionId];
    } else {
      newFilters[sessionId] = clauses;
    }

    setFilters(newFilters);
  };

  return { setFiltersForSession, filters };
};
